import { useTranslation } from 'react-i18next';
import * as apiUser from 'api/apiUsers';
import { useToast } from 'context/ToastContext';
import { useAuth } from 'context/AuthContext';
import type { FetchUsersFn } from '../types';
import type { UserType } from '@econtractor/types';

interface UserStatItemsProps {
    user: UserType;
    setShowSpinner: (value: boolean) => void;
    fetchUsers: FetchUsersFn;
}

const UserStatItems = ({ user, setShowSpinner, fetchUsers }: UserStatItemsProps) => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const { auth } = useAuth();

    const handleClickStatus = (active: boolean) => {
        if (user.ID == auth.user.ID) return showToast(t('Users.messChangeSelf'), 'danger');

        (async () => {
            setShowSpinner(true);
            const resStatus = await apiUser.setStatus(user.ID, active);
            await fetchUsers(true);
            if (!resStatus) showToast(t('messError'), 'danger');
            setShowSpinner(false);
        })();
    };

    return (
        <>
            {user.userStatus ? (
                <span
                    className="badge bg-light-success cursor-pointer no-select"
                    title={t('Users.changeStat')}
                    onClick={() => handleClickStatus(false)}>
                    {t('Users.statActive')}
                </span>
            ) : (
                <span
                    className="badge bg-light-danger cursor-pointer no-select"
                    title={t('Users.changeStat')}
                    onClick={() => handleClickStatus(true)}>
                    {t('Users.statBlock')}
                </span>
            )}
        </>
    );
};

export default UserStatItems;
